import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';

declare const $: any;

@Component({
    selector: 'app-question-textbox-icon',
    templateUrl: './question-textbox-icon.component.html',
    styleUrls: ['./question-textbox-icon.component.scss'],
    standalone: false
})
export class QuestionTextboxIconComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() isIdInput = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  value = '';

  constructor(private questionService: GlobalQuestionService) { }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = this.question.answer;
    }
  }

  ngAfterViewInit(): void {
    this.questionService.initPopoverCustomize();
  }

  saveValue(): void {
    if (this.isIdInput) {
      if (this.validateIdNumber(this.value)) {
        this.question.answer = this.value;
        this.questionAnswer.emit(this.question);
      }
    } else {
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
    }
  }

  validateIdNumber(value: any): boolean {
    const regex = new RegExp(/^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/);
    // apply Luhn formula for check-digits
    let tempTotal = 0;
    let checkSum = 0;
    let multiplier = 1;
    for (let i = 0; i < 13; ++i) {
      tempTotal = (+value.charAt(i)) * multiplier;
      if (tempTotal > 9) {
        tempTotal = (+tempTotal.toString().charAt(0)) + (+tempTotal.toString().charAt(1));
      }
      checkSum = checkSum + tempTotal;
      multiplier = (multiplier % 2 === 0) ? 1 : 2;
    }
    if ((checkSum % 10) !== 0) {
      return false;
    }
    return regex.test(value);
  }
}
